<modal-form-container
  title="Choose tags"
  className="md:w-[720px] lg:w-[760px]"
  [showModal]="open"
  (closeModalEvent)="closeModal()"
>
  @if (open) {
    <div class="gm">
      <bk-group-picker kind="tag" [selected]="selectedTags" (selectedChange)="onPick($event)" />

      <div class="gm__foot">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="closeModal()">Cancel</button>
        <button type="button" class="bk-btn bk-btn--primary" (click)="emitSelection()">
          {{ selectedTags.length ? 'Use ' + selectedTags.length + ' selected' : 'Clear tags' }}
        </button>
      </div>
    </div>
  }
</modal-form-container>
